var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"535d71eefb61f1c83c30ad094bfe55a47a02b855"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web@higher-learning-technologies"]={id:"535d71eefb61f1c83c30ad094bfe55a47a02b855"};
      